module.exports = __webpack_public_path__ + "static/media/trash.40f86e73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lessonbuilder/trash.svg
// module id = 570
// module chunks = 0